import {useEffect, useState} from "react";
import httpServices from "../../services/http-services";
import {toast} from "react-toastify";
import isCancel from "../../services/http";
import config from "../../config/apiService.json";

const useAbout = () => {
    const { about } = config;
    const [data, setData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const update = (entity, id) => {
        setLoading(true);
        httpServices
        .update(`/administrative${about}/${id}`, entity)
        .then((res) => {
            const updatedData = {...data};
            updatedData.description = res.data.payload.description;
            setData(updatedData);
            setLoading(false);
            toast.success("Successfully Updated!");
        })
        .catch((error) => {
            console.log(error);
            setError(error.message);
            setLoading(false);
            toast.error("Update Failed!");
        });
    };

    useEffect(() => {
        const {request, cancel} = httpServices.getAll(about);
        setLoading(true);
        request
        .then(({data: {payload}}) => {
            setData(payload);
            setLoading(false);
        })
        .catch((error) => {
            if (isCancel(error)) return;
            console.log(error);
            setError(error.message);
            setLoading(false);
        });

        return () => cancel();
    }, []);

    return {data, isLoading, error, update};
};

export default useAbout;
